import GR1 from '@rategravity/frontend/theme/webfonts/Graphik-Regular.eot';
import GR2 from '@rategravity/frontend/theme/webfonts/Graphik-Regular.eot?#iefix';
import GR5 from '@rategravity/frontend/theme/webfonts/Graphik-Regular.ttf';
import GR4 from '@rategravity/frontend/theme/webfonts/Graphik-Regular.woff';
import GR3 from '@rategravity/frontend/theme/webfonts/Graphik-Regular.woff2';

export const GraphikRegular = {
  src: `url(${GR1}), url(${GR2}), url(${GR3}), url(${GR4}), url(${GR5})`
};
